import { notifications } from '@mantine/notifications';
import { errorText } from './api';

export const notifyOk = (message: string) => notifications.show({ color: 'green', message });
/** Ostrzeżenie: operacja częściowo udana (np. wpłata zapisana, faktura nie) — dłużej widoczne. */
export const notifyWarn = (message: string, title?: string) => notifications.show({ color: 'yellow', title, message, autoClose: 10_000 });
export const notifyError = (err: unknown) =>
  notifications.show({ color: 'red', title: 'Operacja nie powiodła się', message: errorText(err), autoClose: 8000, style: { whiteSpace: 'pre-line' } });
